<template>
  <f7-page no-swipeback>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-md="material:menu" panel-open="left"/>
      </f7-nav-left>
      <f7-nav-title>{{$t('title.myCard')}}</f7-nav-title>
      <f7-subnavbar sliding>
        <f7-segmented>
          <f7-button :href="links.myCard" tab-link tab-link-active>{{$t('title.overview')}}</f7-button>
          <f7-button :href="links.spend" tab-link>{{$t('title.spend')}}</f7-button>
        </f7-segmented>
      </f7-subnavbar>
    </f7-navbar>
    <aio-card :card="myCard"/>
    <f7-block v-if="isPending" v-html="$t('text.pendingCard')"/>
    <div v-else>
      <f7-block>
        <f7-button fill @click="freezeCard" v-if="myCard.status === 'Active'">Freeze card</f7-button>
        <f7-button fill @click="unfreezeCard" v-if="myCard.status === 'Suspended'" :disabled="suspendedByAdmin">Unfreeze card</f7-button>
        <strong class="warn-text" v-if="suspendedByAdmin">Your card was frozen by your manager. Only they can unfreeze it.</strong>
        <f7-link href="https://getaio.co.uk/terms-conditions/" external target="_blank">Terms and Conditions</f7-link>
        <f7-link class="lost-link" @click="showInfo">Lost or stolen?</f7-link>
      </f7-block>
      <f7-list>
        <f7-list-item :title="$t('label.balance')" :after="formatMoney(myCard.currency, myCard.balance)"/>
        <f7-list-item :title="$t('label.lastTransaction')"
                      :after="formatMoney(myCard.currency, myCard.lastTransaction)"/>
        <f7-list-item :title="$t('label.requested')" :after="formatMoney(myCard.currency, myCard.requested)"/>
        <f7-list-item :title="$t('label.allocated')" :after="formatMoney(myCard.currency, myCard.allocated)"/>
        <f7-list-item :title="$t('label.spent')" :after="formatMoney(myCard.currency, myCard.spent)"/>
      </f7-list>
    </div>
    <main-toolbar slot="fixed" :active="2"/>
  </f7-page>
</template>

<script>
  import AioCard from '../components/aio-card'
  import api from 'aio-api'
  import helpers from '@/utils/helpers'
  import MainToolbar from '../components/main-toolbar'

  export default {
    name: 'my-card',
    components: {
      AioCard,
      MainToolbar
    },
    computed: {
      isPending () {
        return this.myCard.status === 'pending'
      },
      suspendedByAdmin () {
        return this.myCard.suspendedBy && (this.myCard.suspendedBy !== this.currentUserId)
      }
    },
    created () {
      this.$store.dispatch('fetchCard')
    },
    methods: {
      freezeCard () {
        this.$f7.dialog.confirm('Are you sure you want to freeze your card? You won\'t be able to use it for any purchases while frozen.', '', async () => {
          await api.freezeCard(this.currentUserId)
          this.$store.dispatch('fetchCard')
        })
      },
      async unfreezeCard () {
        await api.unfreezeCard(this.currentUserId)
        this.$store.dispatch('fetchCard')
      },
      showInfo () {
        this.$f7.dialog.alert(`If your card was lost or stolen, you should freeze it and get in touch with us via <a href="${this.links.help}">Help</a> so we can send you a replacement card.`, '')
      }
    },
    mixins: [helpers]
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';

  .lost-link {
    float: right;
  }

  .warn-text {
    color: $el-salmon;
  }
</style>
